import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { PontosCriticosProjeto } from '../../models/pontos-criticos-projeto.model';
import { PontosCriticosTipos } from '../../models/pontos-criticos-tipos.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PontosCriticosAgregadorIndicadorService } from '../../services/pontos-criticos-agregador-indicador.service';
import { PontosCriticosProjetoEntregaService } from '../../services/pontos-criticos-projeto-entrega.service';
import { PontosCriticosProjetoIndicadorService } from '../../services/pontos-criticos-projeto-indicador.service';
import { PontosCriticosProjetoService } from '../../services/pontos-criticos-projeto.service';

@Component({
  selector: 'app-detalhe-projeto-pontos-criticos-edit',
  templateUrl: './detalhe-projeto-pontos-criticos-edit.component.html',
  styleUrls: ['./detalhe-projeto-pontos-criticos-edit.component.scss']
})
export class DetalheProjetoPontosCriticosEditComponent extends BaseFormComponent<PontosCriticosProjeto> implements OnInit {
  idProjeto: number;
  idEntrega: number;
  idIndicador: number;
  idPgIndicador: number;
  infoProjeto: ProjetoCadastro;
  canEdit: boolean;
  canEditNotEspec: boolean;
  actionLabel: string = 'Novo';
  audit: AtualizacoesAudit;
  tiposList: PontosCriticosTipos[];
  statusList: any[];
  probabilidadesList: any[];
  impactoList: any[];
  listUsuario: any[];
  sensivelList: any[];
  myService: any; // service que será usado conforme o tipo de ponto crítico (projeto, entrega, indicador)
  permissions: ProjetoPermission;
  pgIndicador: boolean = false;

  constructor(
    private pcProjetoService: PontosCriticosProjetoService,
    private pcEntregaService: PontosCriticosProjetoEntregaService,
    private pcIndicadorService: PontosCriticosProjetoIndicadorService,
    private pcAgregadorIndicadorService: PontosCriticosAgregadorIndicadorService,
    public activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private pesquisaGeralService: PesquisaGeralService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pgIndicador = this.activatedRoute.snapshot.data['pgIndicador'];

    this.loading();
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });

    this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];

    if (this.entity) {
      this.validaIds();

      // update ponto critico, navegado a partir do método editarClickHandler do DetalheProjetoPontosCriticosListComponent
      if (this.entity.prt_issue_id) {
        this.idEntrega = this.entity.prt_issue_id;
        this.myService = this.pcEntregaService;
      } else if (this.entity.ind_id) {
        if (this.activatedRoute.snapshot.params.idPgIndicador) {
          this.idPgIndicador = this.activatedRoute.snapshot.params.idPgIndicador;
          this.myService = this.pcAgregadorIndicadorService;
        } else {
          this.idIndicador = this.entity.ind_id;
          this.myService = this.pcIndicadorService;
        }
      } else { // projeto
        this.myService = this.pcProjetoService;
      }
    } else {
      // create ponto critico, navegado a partir do método novo do DetalheProjetoPontosCriticosListComponent
      // parametros nomeados no arquivo de rotas projeto-completo.routing.ts: :idEntrega, :idIndicador, :idPgIndicador
      if (this.activatedRoute.snapshot.params.idEntrega) {
        this.idEntrega = this.activatedRoute.snapshot.params.idEntrega;
        this.myService = this.pcEntregaService;
      } else if (this.activatedRoute.snapshot.params.idIndicador) {
        this.idIndicador = this.activatedRoute.snapshot.params.idIndicador;
        this.myService = this.pcIndicadorService;
      } else if (this.activatedRoute.snapshot.params.idPgIndicador) {
        this.idPgIndicador = this.activatedRoute.snapshot.params.idPgIndicador;
        this.myService = this.pcAgregadorIndicadorService;
      } else { // projeto
        this.myService = this.pcProjetoService;
      }
    }

    this.pcProjetoService.getOpcoesCombobox().subscribe((data) => {
      if (this.idIndicador) {
        this.statusList = data['statusIndicador'];
      } else {
        this.statusList = data['status'];
      }

      this.tiposList = data['tipos'];
      this.probabilidadesList = data['probabilidades'];
      this.impactoList = data['impactos'];
      this.sensivelList = data['sensivel'];

      this.loaded();
    });

    this.initForm();
  }

  validaIds() {
    // Valida se o ponto critico (entity) pertence ao projeto cujo id está na rota
    if (!this.idPgIndicador && this.entity.pf_id != this.idProjeto) { // projeto, agregador não possui idProjeto na rota
      this.voltar();
    }
    // valida se o ponto critico (entity) pertence ao indicador ou entrega cujo id está na rota
    if (this.idIndicador) {
      this.validaId(this.idIndicador, this.entity.ind_id);
    } else if (this.idEntrega) {
      this.validaId(this.idEntrega, this.entity.prt_issue_id);
    } else if (this.idPgIndicador) { // indicador do projeto agregador/programa
      this.validaId(this.idPgIndicador, this.entity.ind_id);
    }
  }

  validaId(id1: any, id2: any) {
    if (id1 != id2) {
      this.voltar();
    }
  }

  initForm() {
    if (this.idPgIndicador) {
      this.form = this.fb.group({
        id: [''],
        critical_stat_id: [null, [Validators.required]],
        critical_type_id: [null],
        description: ['', [Validators.required, Validators.maxLength(300)]],
      });
    } else {
      this.form = this.fb.group({
        id: [''],
        critical_stat_id: [null, [Validators.required]],
        critical_type_id: [null],
        critical_probability_id: [null, [Validators.required]],
        critical_impact_id: [null, [Validators.required]],
        sensitive_id: [null],
        manager_main: [null, [Validators.required]],
        manager_adjunct: [null],
        description: ['', [Validators.required, Validators.maxLength(300)]],
      });
    }

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.canEdit = this.entity.canEdit;
      this.canEditNotEspec = this.entity.canEditNotEspec;

      if (this.idIndicador) {
        this.audit = {
          ind_critical_id: this.entity.id
        };
      } else if (this.idEntrega) {
        this.audit = {
          prt_issue_critical_id: this.entity.id
        };
      } else if (this.idPgIndicador) {
        this.audit = {
          pg_ind_critical_id: this.entity.id
        };
      } else {
        this.audit = {
          critical_id: this.entity.id
        };
      }
    }
  }

  voltar() {
    this.navigation.back();
  }

  getDataCreate(): PontosCriticosProjeto {
    let data: PontosCriticosProjeto;
    data = Object.assign({}, data, this.form.value);

    if (this.idIndicador || this.idPgIndicador) {
      data.ind_id = this.idIndicador ? this.idIndicador : this.idPgIndicador;
    } else if (this.idEntrega) {
      data.prt_issue_id = this.idEntrega;
    } else {
      data.pf_id = this.idProjeto;
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();

      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: PontosCriticosProjeto) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: PontosCriticosProjeto) => {
              // this.increasePontosCriticosItens();
              this.confirmation().subscribe(() => {
                if (this.idEntrega) {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', res.id]);
                } else if (this.idIndicador) {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', res.id]);
                } else if (this.idPgIndicador) {
                  this.navigation.replace(['projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico',  res.id]);
                } else { // projeto
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', res.id]);
                }
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  // increasePontosCriticosItens() {
  //   if (!this.idPgIndicador) {
  //     this.infoProjeto.menu['pontos-criticos'].itens++;
  //     this.pesquisaGeralService.setInfoProject(this.infoProjeto);
  //   }
  // }
}
